import { inject, injectable } from 'tsyringe';
import { PersistentStorageService } from '../../persistent-storage-service/persistent-storage.service';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import {
  IUserActionService,
  IUserActionServiceDelegate,
  kNameOfUserActionService,
} from '../../../interfaces/user-action-service.interface';
import { LoggerService } from '../../logger.service';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.AllApps)
export class ConditionApplicationExcluded
  implements ICondition, IUserActionServiceDelegate
{
  private readonly logger = LoggerService.getCategory(
    'ConditionApplicationExcluded',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly storage: PersistentStorageService,
    @inject(kNameOfUserActionService)
    private readonly userActionService: IUserActionService,
  ) {
    this.userActionService.addListener(this);
  }

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const excludedGames = this.storage.getExcludedExtensions();
    if (!excludedGames) {
      return [true, null];
    }

    if (excludedGames.includes(context.application.uid)) {
      return [false, NoRecommendationsReasons.AppExcludedByUser];
    }

    return [true, null];
  }

  // ---------------------------------------------------------------------------
  // IUserActionServiceDelegate
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  onApplicationExcluded(extensionId: string) {
    this.storage.addExtensionToExcluded(extensionId);
  }
}
